/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseLineAnnotation = dynamic(
  () => import('../tasks/TaskResponseImageLineAnnotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export const realResponse = {
  annotations: [
    {
      key: '148fd109-9fa4-46ae-a0f2-c02478a98d54',
      vertices: [
        {
          x: 472,
          y: 297
        },
        {
          x: 488,
          y: 301
        },
        {
          x: 502,
          y: 309
        },
        {
          x: 513,
          y: 323
        },
        {
          x: 515,
          y: 340
        },
        {
          x: 511,
          y: 357
        },
        {
          x: 502,
          y: 369
        },
        {
          x: 493,
          y: 377
        },
        {
          x: 480,
          y: 380
        },
        {
          x: 464,
          y: 381
        },
        {
          x: 450,
          y: 375
        },
        {
          x: 439,
          y: 365
        },
        {
          x: 432,
          y: 351
        },
        {
          x: 430,
          y: 331
        },
        {
          x: 435,
          y: 318
        },
        {
          x: 444,
          y: 307
        },
        {
          x: 455,
          y: 299
        },
        {
          x: 471,
          y: 296
        }
      ],
      label: 'circles',
      complete: true
    },
    {
      key: '85945fed-c8a2-4297-a43c-6f00723934e3',
      vertices: [
        {
          x: 271,
          y: 335
        },
        {
          x: 272.6666666666667,
          y: 327.3333333333333
        },
        {
          x: 280.6666666666667,
          y: 324
        },
        {
          x: 288,
          y: 326
        },
        {
          x: 291.3333333333333,
          y: 331.3333333333333
        },
        {
          x: 291.3333333333333,
          y: 340
        },
        {
          x: 287.3333333333333,
          y: 346.6666666666667
        },
        {
          x: 278.6666666666667,
          y: 348.6666666666667
        },
        {
          x: 272,
          y: 342
        },
        {
          x: 270.6666666666667,
          y: 335.3333333333333
        }
      ],
      label: 'circles',
      complete: true
    },
    {
      key: '4b9bd16f-fdff-4eac-affc-1b1b65bd956d',
      vertices: [
        {
          x: 302,
          y: 324.6666666666667
        },
        {
          x: 310,
          y: 326.6666666666667
        },
        {
          x: 314.6666666666667,
          y: 332.6666666666667
        },
        {
          x: 315.3333333333333,
          y: 341.3333333333333
        },
        {
          x: 310,
          y: 346.6666666666667
        },
        {
          x: 302.6666666666667,
          y: 349.3333333333333
        },
        {
          x: 296.6666666666667,
          y: 346.6666666666667
        },
        {
          x: 292,
          y: 339.3333333333333
        },
        {
          x: 292,
          y: 330.6666666666667
        },
        {
          x: 300,
          y: 324.6666666666667
        }
      ],
      label: 'circles',
      complete: true
    },
    {
      key: '0938737c-69fb-4641-a00d-be0cccfe7ac5',
      vertices: [
        {
          x: 645.3333333333334,
          y: 329.3333333333333
        },
        {
          x: 652,
          y: 332
        },
        {
          x: 656,
          y: 337.3333333333333
        },
        {
          x: 657.3333333333334,
          y: 344.6666666666667
        },
        {
          x: 653.3333333333334,
          y: 350.6666666666667
        },
        {
          x: 646.6666666666666,
          y: 354
        },
        {
          x: 638,
          y: 352
        },
        {
          x: 632.6666666666666,
          y: 346
        },
        {
          x: 632,
          y: 338
        },
        {
          x: 636,
          y: 332.6666666666667
        },
        {
          x: 644.6666666666666,
          y: 328
        }
      ],
      label: 'circles',
      complete: true
    },
    {
      key: '4cead47d-c905-4266-a81a-ac533875814e',
      vertices: [
        {
          x: 668,
          y: 330
        },
        {
          x: 675.3333333333334,
          y: 332
        },
        {
          x: 680.6666666666666,
          y: 336.6666666666667
        },
        {
          x: 680.6666666666666,
          y: 344
        },
        {
          x: 677.3333333333334,
          y: 352
        },
        {
          x: 668.6666666666666,
          y: 354
        },
        {
          x: 659.3333333333334,
          y: 349.3333333333333
        },
        {
          x: 658,
          y: 341.3333333333333
        },
        {
          x: 660,
          y: 335.3333333333333
        },
        {
          x: 666.6666666666666,
          y: 330
        }
      ],
      label: 'circles',
      complete: true
    },
    {
      key: '84b610f9-cc2a-4bbf-9e18-f0c12e7e21d7',
      vertices: [
        {
          x: 243,
          y: 209
        },
        {
          x: 238,
          y: 462
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '8dd586c1-4adf-43e7-9144-23d30d1ee4e5',
      vertices: [
        {
          x: 241,
          y: 209
        },
        {
          x: 714,
          y: 214
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'a57af8f1-1180-4300-aa78-a94ce03cce9e',
      vertices: [
        {
          x: 242,
          y: 243
        },
        {
          x: 318,
          y: 245
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '47e393e9-0470-4fb1-b3c8-e65d9a7c919e',
      vertices: [
        {
          x: 241,
          y: 294
        },
        {
          x: 266,
          y: 294
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '44ef99e7-c6fe-4ec7-afaf-0d9a49349c11',
      vertices: [
        {
          x: 240,
          y: 377
        },
        {
          x: 264,
          y: 378
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '456346d8-0809-451c-8792-08afbface837',
      vertices: [
        {
          x: 239,
          y: 427
        },
        {
          x: 313,
          y: 429
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'ec8a70d3-0b90-4bec-bbdf-600cb899b455',
      vertices: [
        {
          x: 713,
          y: 472
        },
        {
          x: 238,
          y: 464
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '3b4f19a1-8981-4db5-8e9f-cfda8c0ec917',
      vertices: [
        {
          x: 631,
          y: 436
        },
        {
          x: 712,
          y: 438
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'b614af99-38e4-44ab-83fe-6eb14c6a5ada',
      vertices: [
        {
          x: 685,
          y: 384
        },
        {
          x: 711,
          y: 385
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'dae0eb27-0d15-4103-8e31-cce7422da456',
      vertices: [
        {
          x: 688,
          y: 300
        },
        {
          x: 712,
          y: 301
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'f1a0b409-c699-40ba-8bda-1bc5760e2a0e',
      vertices: [
        {
          x: 632,
          y: 248
        },
        {
          x: 711,
          y: 248
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '0e984b2f-3d9a-46d1-a37f-637934edb2e1',
      vertices: [
        {
          x: 265,
          y: 294
        },
        {
          x: 264,
          y: 377
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '1b547f86-fcf8-4966-a749-772dc1653d16',
      vertices: [
        {
          x: 317,
          y: 246
        },
        {
          x: 314,
          y: 429
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'c72ee679-dcee-4b5a-b743-2e9751b5ee16',
      vertices: [
        {
          x: 283,
          y: 266
        },
        {
          x: 281,
          y: 404
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'b0329cbe-2005-441b-9444-f840fe9b4d10',
      vertices: [
        {
          x: 410,
          y: 212
        },
        {
          x: 409,
          y: 462
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '1d3bbdfd-8628-4d66-98f2-5c7abca43e3a',
      vertices: [
        {
          x: 473,
          y: 213
        },
        {
          x: 471,
          y: 465
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'c8a2ec7d-bc42-412e-9c91-88428f040138',
      vertices: [
        {
          x: 536,
          y: 214
        },
        {
          x: 535,
          y: 466
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '97b482fe-b66d-4a4a-ae05-fd556374a618',
      vertices: [
        {
          x: 632,
          y: 248
        },
        {
          x: 632,
          y: 434
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'eb5390b7-b949-4694-997e-290410f4d50d',
      vertices: [
        {
          x: 668,
          y: 273
        },
        {
          x: 667,
          y: 408
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'd8a3ae6c-85b2-4364-adb0-594f9a636192',
      vertices: [
        {
          x: 686,
          y: 300
        },
        {
          x: 685,
          y: 384
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '819bdbb1-1a60-4660-9d77-47097ffba811',
      vertices: [
        {
          x: 712,
          y: 214
        },
        {
          x: 712,
          y: 472
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'a13b6ba5-cc14-4fb6-9c1b-46114886ecf6',
      vertices: [
        {
          x: 285,
          y: 321
        },
        {
          x: 310,
          y: 295
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'f627ce45-60a1-4e4f-bdb3-b43c98bc5a45',
      vertices: [
        {
          x: 284,
          y: 348
        },
        {
          x: 309,
          y: 375
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '5d1d3953-ef08-4bd4-beab-6424951e7722',
      vertices: [
        {
          x: 666,
          y: 328
        },
        {
          x: 638,
          y: 300
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '5cbd7263-08c7-44ef-aa84-08a91b1b3ec9',
      vertices: [
        {
          x: 667,
          y: 354
        },
        {
          x: 637,
          y: 383
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '1b2973d8-f975-4994-ad47-18f92c03754f',
      vertices: [
        {
          x: 244,
          y: 253
        },
        {
          x: 387,
          y: 254
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '8f45ce88-2e8d-4563-ab98-fca664bca7fc',
      vertices: [
        {
          x: 240,
          y: 418
        },
        {
          x: 386,
          y: 421
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'c0ff4b5a-ce6f-4003-b692-2d8889eec62a',
      vertices: [
        {
          x: 430,
          y: 253
        },
        {
          x: 515,
          y: 254.99999999999997
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '22071e1a-2ae2-4a3d-8192-f893414b83a9',
      vertices: [
        {
          x: 429,
          y: 421
        },
        {
          x: 512,
          y: 424
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'b84a4bd6-daba-42ea-b51a-e6ce50947ee2',
      vertices: [
        {
          x: 560,
          y: 256
        },
        {
          x: 711,
          y: 257
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'fc82809e-0c70-480f-94f1-f1c6f33cc22e',
      vertices: [
        {
          x: 390,
          y: 212
        },
        {
          x: 386,
          y: 464
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: '04725a5b-aa32-480e-a344-1bb094704363',
      vertices: [
        {
          x: 559,
          y: 214
        },
        {
          x: 556,
          y: 465
        }
      ],
      label: 'line',
      complete: true
    },
    {
      key: 'c1897d3c-847c-42ab-9d61-53ff05911827',
      vertices: [
        {
          x: 556,
          y: 424
        },
        {
          x: 713,
          y: 429
        }
      ],
      label: 'line',
      complete: false
    }
  ]
};

export const instruction = 'Annotate all the lines and circles of the field.';

const responseCode = `{
  "annotations": [
    {
      "vertices": [
        {
          "x": 472,
          "y": 297
        },
        {
          "x": 488,
          "y": 301
        },
        {
          "x": 502,
          "y": 309
        },
        {
          "x": 513,
          "y": 323
        },
        {
          "x": 515,
          "y": 340
        },
        {
          "x": 511,
          "y": 357
        },
        {
          "x": 502,
          "y": 369
        },
        {
          "x": 493,
          "y": 377
        },
        {
          "x": 480,
          "y": 380
        },
        {
          "x": 464,
          "y": 381
        },
        {
          "x": 450,
          "y": 375
        },
        {
          "x": 439,
          "y": 365
        },
        {
          "x": 432,
          "y": 351
        },
        {
          "x": 430,
          "y": 331
        },
        {
          "x": 435,
          "y": 318
        },
        {
          "x": 444,
          "y": 307
        },
        {
          "x": 455,
          "y": 299
        },
        {
          "x": 471,
          "y": 296
        }
      ],
      "label": "circles",
      "complete": true
    },
    {
      "vertices": [
        {
          "x": 271,
          "y": 335
        },
        {
          "x": 272,
          "y": 327
        },
        {
          "x": 280,
          "y": 324
        },
        {
          "x": 288,
          "y": 326
        },
        {
          "x": 291,
          "y": 331
        },
        {
          "x": 291,
          "y": 340
        },
        {
          "x": 287,
          "y": 346
        },
        {
          "x": 278,
          "y": 348
        },
        {
          "x": 272,
          "y": 342
        },
        {
          "x": 270,
          "y": 335
        }
      ],
      "label": "circles",
      "complete": true
    },
    ...
  ]
}`;

export const code = `client.createLineannotationTask({
  instruction: '${instruction}',
  attachment: 'http://i.imgur.com/XOJbalC.jpg',
  objects_to_annotate: ['edges', 'borders'],
  splines: false,
  with_labels: true
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => (
  <TaskResponseLineAnnotation
    annotations={[]}
    imageURL="/static/img/examples/lines-splines-drones.png"
    rounded
  />
);

export const result = (
  <TaskResponseLineAnnotation
    annotations={realResponse.annotations}
    imageURL="/static/img/examples/lines-splines-drones.png"
    rounded
  />
);
